<template>
  <div>
    <div class="page-title-cont">
      <h1 class="wp-heading-inline">WPCal.io - Please request access</h1>
    </div>
    <div
      style="color: rgb(232, 70, 83); border: 1px dashed rgb(232, 70, 83); padding:5px 7px;background-color: #ffecee; display:inline-block; border-radius: 5px;font-size: 14px;"
    >
      You do not have access to WPCal.
    </div>
    <div class="col-cont settings-cont" style="font-size:15px;">
      <div class="col">
        <ul class="info-lines">
          <li>
            <div style="font-size:14px">
              WPCal Admin features are available to WPCal admins only.
            </div>
          </li>
        </ul>

        <div v-if="content_loaded && contact_wpcal_admins">
          <div>
            Please contact one of admin users below and ask them to add you as a
            WPCal admin.
            <table
              class="mbox settingAdmins"
              style="padding: 0px; width:100%; margin-top:10px; border-collapse: collapse;"
            >
              <tr
                v-for="(admin_detail, index) in contact_wpcal_admins"
                :key="index"
                style=""
              >
                <td
                  style="border-bottom: 1px solid #b1b6d1;width:50%; text-align:right; padding:10px;"
                >
                  {{ admin_detail.wp_name }}
                </td>
                <td
                  style="border-bottom: 1px solid #b1b6d1;width:50%; padding:10px;"
                >
                  <a
                    style="white-space:nowrap;"
                    :href="'mailto:' + admin_detail.email"
                    >{{ admin_detail.email }} &nearr;</a
                  >
                </td>
              </tr>
            </table>
          </div>
        </div>
        <div
          v-else-if="
            content_loaded &&
              current_user_can_be_self_added_as_wpcal_admin &&
              wp_user_id
          "
        >
          <div style="line-height:1.5em; margin-top:20px;">
            It looks like either none of the WPCal admins are active now or no
            one is added as a WPCal admin.<br /><br />
            If you want to manage this plugin, click the button below to add
            yourself as a WPCal Admin.<br />
            This option is available only to WP administrators.
          </div>
          <div style="margin-top:10px;">
            <button
              class="wpc-btn primary lg mt20"
              style="padding:13px;"
              @click="add_current_user_as_wpcal_admin()"
              :disabled="!self_add_btn_is_enabled"
            >
              Add myself as WPCal Admin &amp; Start managing
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      content_loaded: false,
      non_wpcal_admin_details: {},
      self_add_btn_is_enabled: true
    };
  },
  computed: {
    contact_wpcal_admins() {
      return this.non_wpcal_admin_details?.list_of_admins_to_contact.length
        ? this.non_wpcal_admin_details?.list_of_admins_to_contact
        : false;
    },
    current_user_can_be_self_added_as_wpcal_admin() {
      return this.non_wpcal_admin_details
        ?.while_no_active_wpcal_admins_current_user_can_be_self_added_as_wpcal_admin
        ? true
        : false;
    },
    wp_user_id() {
      return this.non_wpcal_admin_details?.wp_user_id
        ? this.non_wpcal_admin_details?.wp_user_id
        : "";
    }
  },
  methods: {
    get_non_wpcal_admin_details() {
      let wpcal_request = {};
      let action_non_wpcal_admin_details =
        "get_non_wpcal_admin_details_to_show";
      wpcal_request[action_non_wpcal_admin_details] = "dummy__";

      let post_data = {
        action: "wpcal_process_user_ajax_request",
        wpcal_request: wpcal_request
      };
      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          if (
            response.data &&
            response.data[action_non_wpcal_admin_details].hasOwnProperty(
              "non_wpcal_admin_details_to_show"
            )
          ) {
            this.non_wpcal_admin_details =
              response.data[
                action_non_wpcal_admin_details
              ].non_wpcal_admin_details_to_show;
            this.content_loaded = true;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    add_current_user_as_wpcal_admin() {
      this.self_add_btn_is_enabled = false;
      let wpcal_request = {};
      let action_add_current_user_as_wpcal_admin =
        "add_current_user_as_wpcal_admin_while_no_active_wpcal_admins";
      wpcal_request[action_add_current_user_as_wpcal_admin] = {
        wp_user_id: this.wp_user_id
      };

      let post_data = {
        action: "wpcal_process_user_ajax_request",
        wpcal_request: wpcal_request
      };
      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          this.notify_single_action_result(
            response.data[action_add_current_user_as_wpcal_admin],
            { success_msg: this.T__("Successfully added.") }
          );
          if (
            response.data &&
            response.data?.[action_add_current_user_as_wpcal_admin]?.status ==
              "success"
          ) {
            this.content_loaded = false; //hack fix
            window.location.reload();
          }
        })
        .catch(error => {
          console.log(error);
        })
        .then(() => {
          this.self_add_btn_is_enabled = true;
        });
    }
  },
  mounted() {
    this.get_non_wpcal_admin_details();
    if (this.$store.getters.get_is_admin_end_access_granted) {
      this.$router.push("/");
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.$store.getters.get_is_admin_end_access_granted) {
      //initial setup not done, ask admin for login
      //router.app.$router.push("/settings/account/login");
      next(false);
      return;
    }
    next();
  }
};
</script>
